import type React from "react"
import { useEffect } from "react"
import { promoCodeExperimentValues } from "components/Basket/components/PromoCodes/constants"
import { showPromoCodeAllVariants } from "components/Basket/components/PromoCodes/hooks/usePromoCode"
import { ExperimentFlags } from "@shared/utils.experimentation"
import { useFeatureFlag } from "hooks"
import { trackExperimentViewed } from "tracking/hooks/useExperimentViewed"

export const PromoCodeABTestTracking: React.FC = () => {
  const [promoCodeLoading, promoFlagExperimentValue] = useFeatureFlag(
    ExperimentFlags.USE_PROMO_CODE_EXPERIMENT,
    promoCodeExperimentValues.throwaway
  )

  useEffect(() => {
    if (
      !promoCodeLoading &&
      showPromoCodeAllVariants(promoFlagExperimentValue)
    ) {
      trackExperimentViewed(
        ExperimentFlags.USE_PROMO_CODE_EXPERIMENT,
        +promoFlagExperimentValue
      )
    }
  }, [promoCodeLoading, promoFlagExperimentValue])

  return null
}
